(function () {
    "use strict";

    angular
        .module("app")
        .directive("pager", [pager]);

    function pager() {
        return {
            restrict: "E",
            link: function (scope) {

                scope.pagingOptions = [15, 25, 50, 100];

                scope.initPager = function() {
                    scope.firstRecord = null;
                    scope.lastRecord = null;
                    scope.totalRecords = null;
                    scope.currentPageNumber = null;
                    scope.totalPageCount = null;
                    scope.pageSize = null;
                };

                scope.$watch("pagerData", function (newValue) {
                    if (!newValue) {
                        scope.initPager();
                        return;
                    }

                    scope.totalRecords = newValue.TotalRecords;
                    scope.currentPageNumber = newValue.CurrentPageNumber;
                    scope.totalPageCount = newValue.TotalPageCount;
                    scope.pageSize = newValue.PageSize;

                    if (scope.totalRecords > 0) {
                        scope.firstRecord = ((newValue.CurrentPageNumber - 1) * newValue.PageSize) + 1;
                        scope.lastRecord = Math.min(scope.firstRecord + newValue.PageSize - 1, scope.totalRecords);
                    } else {
                        scope.firstRecord = 0;
                        scope.lastRecord = 0;
                    }
                });

                scope.loadCurrentPage = function () {
                    scope.loadPage({ pageNumber: scope.currentPageNumber, pageSize: scope.pageSize });
                };

                scope.prev = function () {
                    if (scope.currentPageNumber > 0) {
                        scope.currentPageNumber--;
                        scope.loadCurrentPage();
                    }
                };

                scope.next = function () {
                    if (scope.currentPageNumber < scope.totalPageCount) {
                        scope.currentPageNumber++;
                        scope.loadCurrentPage();
                    }
                };

                scope.home = function() {
                    scope.currentPageNumber = 1;
                    scope.loadCurrentPage();
                };

                scope.end = function () {
                    scope.currentPageNumber = scope.totalPageCount;
                    scope.loadCurrentPage();
                };

                scope.onPageChanged = function () {
                    scope.loadCurrentPage();
                };

                scope.onPageSizeChanged = function () {
                    scope.loadCurrentPage();
                };

                scope.initPager();
            },
            scope: {
                loadPage: "&", // Expects a function with signature: fn(pageNumber, pageSize)
                pagerData: "=" // Expects an object with properties: CurrentPageNumber, PageSize, TotalRecords, TotalPageCount (matches PagedResult.cs)
            },
            templateUrl: templateUrl("app/directives/pager.html")
        };
    }
})();

